import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import LanguageIcon from '@mui/icons-material/Language'
import AccountBalanceIcon from '@mui/icons-material/AccountBalance'
import { PAYMENT_ACCOUNT_LABELS, VoucherType } from '../../types'

type PaymentAccountBadgesProps = {
  voucher: Pick<VoucherType, 'invoice_currency' | 'payment_account'>
}

const PaymentAccountBadges: React.FC<PaymentAccountBadgesProps> = ({
  voucher,
}) => (
  <>
    {voucher.invoice_currency && voucher.invoice_currency !== 'SEK' && (
      <Tooltip
        title={`International payment: invoice in ${voucher.invoice_currency}`}
      >
        <LanguageIcon
          fontSize="small"
          sx={{ color: 'info.main', flexShrink: 0 }}
        />
      </Tooltip>
    )}
    {voucher.payment_account && voucher.payment_account !== 'AMIN' && (
      <Tooltip
        title={`Paid from ${PAYMENT_ACCOUNT_LABELS[voucher.payment_account]}`}
      >
        <AccountBalanceIcon
          fontSize="small"
          sx={{ color: 'info.main', flexShrink: 0 }}
        />
      </Tooltip>
    )}
  </>
)

export default PaymentAccountBadges
